import React from 'react'
import WhatsappWidget from '../../components/common/WhatsappWidget';
import { Route, Routes, BrowserRouter as Router } from 'react-router-dom';
import WebLayout from './components/layout/WebLayout';
import Avantajlar from './pages/Avantajlar';
import HemenBasvur from './pages/HemenBasvur';
import Iletisim from './pages/Iletisim';
import Index from './pages/Index';
import Kvkk from './pages/Kvkk';
import Sss from './pages/SSS';
import NasilCalisir from './pages/NasilCalisir';
import Urunler from './pages/Urunler';
import ShellTTS from './pages/Urunler/ShellTTS';
import ShellPratikKart from './pages/Urunler/ShellPratikKart';
import ShellPartnerCard from './pages/Urunler/ShellPartnerCard';
import AracTakipSistemi from './pages/Urunler/AracTakipSistemi';
import Hgs from './pages/Urunler/Hgs';
import KrediKartiIleShellTasitTanima from './pages/Urunler/KrediKartiIleShellTasitTanima';
import TTSFormSuccess from './components/common/TTSFormSuccess';

export default function WebRoutes() {
  return (
    <>
      <WhatsappWidget />
        <Routes>
          <Route path="/*" element={<WebLayout />}>
            <Route index element={<Index />} />
            <Route path="avantajlar" element={<Avantajlar />} />
            <Route path="hemen-basvur" element={<HemenBasvur />} />
            <Route path="tts-basvuru-basarili" element={<TTSFormSuccess />} />
            <Route path="iletisim" element={<Iletisim />} />
            <Route path="kvkk" element={<Kvkk />} />
            <Route path="sikca-sorulan-sorular" element={<Sss />} />
            <Route path="nasil-calisir" element={<NasilCalisir />} />
            <Route path="urunler" element={<Urunler />} />
            <Route
              path="urunler/shell-tasit-tanima-sistemi"
              element={<ShellTTS />}
            />
            <Route
              path="urunler/shell-pratik-kart"
              element={<ShellPratikKart />}
            />
            <Route
              path="urunler/shell-partner-card"
              element={<ShellPartnerCard />}
            />
            <Route
              path="urunler/arac-takip-sistemi"
              element={<AracTakipSistemi />}
            />
            <Route path="urunler/hizli-gecis-sistemi-hgs" element={<Hgs />} />
            <Route
              path="urunler/kredi-karti-ile-shell-tasit-tanima"
              element={<KrediKartiIleShellTasitTanima />}
            />
          </Route>
        </Routes>
    </>
  );
}
